import request from "../request"
import qs from "qs";


export function getEmergencyDataById(params) {
  return request.get({
    url: "/rescue/detail",
    params: params
  })
}
export function deleteEmergencyData(params) {
    return request.delete({
        url: "/rescue/del",
        params: params
    })
}
export function getEmergencyTableData(params) {
  return request.get({
    url: "/rescue/page",
    params: params
  })
}

export function auditEmergency(params) {
    return request.put({
        url: '/rescue/audit', 
        params: params
    })
}



